import React from 'react';
import PropTypes from 'prop-types';

export const Label = (props) => {
  return <label>{props.content}</label>
};

Label.propTypes = {
  content: PropTypes.string
};



// WEBPACK FOOTER //
// src/client/components/common/CMS/elements/Label.js